__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "Pricing";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@newrelic/browser-agent/loaders/micro-agent", "1.246.0", () => (__webpack_require__.e(2837).then(() => (() => (__webpack_require__(2837))))));
			register("@slido/core-react", "1", () => (Promise.all([__webpack_require__.e(6621), __webpack_require__.e(9092)]).then(() => (() => (__webpack_require__(9092))))));
			register("@slido/ui-react", "1", () => (Promise.all([__webpack_require__.e(6621), __webpack_require__.e(3740), __webpack_require__.e(7346)]).then(() => (() => (__webpack_require__(7346))))));
			register("eventemitter3", "5.0.1", () => (__webpack_require__.e(7429).then(() => (() => (__webpack_require__(7429))))));
			register("react-dom/client", "18.3.1", () => (__webpack_require__.e(1886).then(() => (() => (__webpack_require__(1886))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(8485), __webpack_require__.e(2967)]).then(() => (() => (__webpack_require__(8485))))));
			register("react-intl", "7.1.11", () => (Promise.all([__webpack_require__.e(6629), __webpack_require__.e(5348)]).then(() => (() => (__webpack_require__(6629))))));
			register("react-jss", "10.9.0", () => (Promise.all([__webpack_require__.e(7605), __webpack_require__.e(8205)]).then(() => (() => (__webpack_require__(7605))))));
			register("react", "18.3.1", () => (__webpack_require__.e(7552).then(() => (() => (__webpack_require__(7552))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};